import { render, staticRenderFns } from "./LegalQuestion.vue?vue&type=template&id=07a065c6&lang=pug&"
import script from "./LegalQuestion.vue?vue&type=script&lang=js&"
export * from "./LegalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LegalQuestion.vue?vue&type=style&index=0&id=07a065c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports